<template>
  <pt-lab-test-platform-update class="pt-lab-test-platform-update__page"></pt-lab-test-platform-update>
</template>

<script>
import PtLabTestPlatformUpdate from 'cps/gene-product/pt-lab-test-platform-update/withData'
export default {
  name: 'pt-lab-test-platform-update__view',
  components: {
    'pt-lab-test-platform-update': PtLabTestPlatformUpdate
  }
}
</script>
